import { PickerSelectedImage } from 'Components/unit/UMediaPicker/UMediaPicker';

import type { CourseAiGenerationStatus } from './redux';

export type ToEditCourseData = {
  dataId: number;
  title?: string;
  description?: string;
  language?: string;
  image?: PickerSelectedImage | null;
};

export type CourseFormData = {
  title: string;
  description?: string;
  languageCountry?: string;
  image?: PickerSelectedImage | null;
  aiGenerationStatus: CourseAiGenerationStatus;
};

export type DuplicateCourseData = {
  id: number;
};

export enum TabsEnum {
  CONTENT = 0,
  AUDIENCE = 1,
}
